// extracted by mini-css-extract-plugin
export default {"offers_section":"HomeFeatures_offers_section__Ahk6M"};